export async function useScrollBottom(el = 'default-element') {
    window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth"
    });

    // если передан элемент, то он будет в фокусе

    if (document.getElementById(el) !== null) {
        document.getElementById(el).focus()
    }

}
